import RoadShowPage from "../../pages/RoadShow";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/_app/roadShow")({
	component: RoadShowPage,
});
